import React from "react";
import './Texte.scss'
import Utils from 'utils/Utils';

function Texte({bloc,prevId}) {
  return <div className="bloc-texte" id={prevId}>{Utils.parseWithLinks(bloc.texte)}</div>;
}
export default Texte;
